import querystring from "query-string";
import { Flex, Paper, Ingress } from "@base-ui";
import Image from "@cms/components/ui/Image";
import IconQuote from "@cms/components/ui/IconQuote";
import fallbackImg from "assets/ux/vis_start_fallback.jpg";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function InternalServerError() {
  var query = querystring.parse(location.search);
  var infographicContent = {
    id: "internal-server-error-iconquote",
    src: "stroke",
    alt: query.database ? "Database server is disconnected" : "Internal server error",
    formattedText: JSON.stringify({
      ops: [{
        insert: "Vi har tekniska problem just nu."
      }, {
        insert: "\n"
      }, {
        insert: "Vi jobbar på att lösa problemen och är snart tillbaka!"
      }]
    })
  };
  return /*#__PURE__*/_jsxs(Flex.Column, {
    height: "calc(100% + 60px)",
    mt: "-60px",
    zIndex: "2",
    overflowY: "auto",
    children: [/*#__PURE__*/_jsx(Flex.Row, {
      minHeight: "60px",
      backgroundColor: "#29484d",
      padding: "0 20px",
      alignItems: "center",
      children: /*#__PURE__*/_jsx(Ingress, {
        inverted: true,
        fontSize: "md",
        children: "V\xE5rden i siffror"
      })
    }), /*#__PURE__*/_jsxs(Flex.Column, {
      position: "relative",
      height: "100%",
      children: [/*#__PURE__*/_jsx(Image, {
        id: "internal-server-error-image",
        src: fallbackImg,
        alt: "",
        minHeight: "100%",
        opacity: ".4"
      }), /*#__PURE__*/_jsx("div", {
        style: {
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          display: "flex"
        },
        children: /*#__PURE__*/_jsx(Paper.Column, {
          p: "md",
          width: "fit-content",
          margin: "auto",
          maxWidth: "450px",
          boxShadow: "0px 1px 1px 0px #c5c5c5",
          children: /*#__PURE__*/_jsx(IconQuote, {
            iconQuote: infographicContent,
            p: "0"
          })
        })
      })]
    })]
  });
}